import { Component, type ReactNode } from "react";
/** Optional rich views must not take down the editor when their resources fail. */
export class FeatureBoundary extends Component<{ children: ReactNode; fallback: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}
